export function sortByTimestampDesc(items) {
  return [...(Array.isArray(items) ? items : [])].sort((a, b) => {
    const at = Number(a?.timestamp) || 0;
    const bt = Number(b?.timestamp) || 0;
    return bt - at;
  });
}

export function getFoodIntakeTotals(items) {
  return (Array.isArray(items) ? items : []).reduce(
    (acc, it) => {
      acc.carbs += Number(it?.carbs) || 0;
      acc.sugarInCarbs += Number(it?.sugarInCarbs) || 0;
      acc.protein += Number(it?.protein) || 0;
      acc.fat += Number(it?.fat) || 0;
      acc.kcal += Number(it?.kcal) || 0;
      return acc;
    },
    { carbs: 0, sugarInCarbs: 0, protein: 0, fat: 0, kcal: 0 }
  );
}

export function formatEpochMillisLocal(timestamp) {
  const t = Number(timestamp);
  if (!Number.isFinite(t) || t <= 0) return '';
  const date = new Date(t);
  return date.toLocaleString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  });
}
